import CityPageTemplate from "../city-template/CityPageTemplate";
import { sanDiegoConfig } from "./data";

export default function SanDiegoPage() {
  return <CityPageTemplate config={sanDiegoConfig} />;
}